module.exports = __webpack_public_path__ + "static/media/trailer.840515c7.svg";